module.exports = __webpack_public_path__ + "static/media/star-wars.4f0533c3.png";